module.exports = __webpack_public_path__ + "img/Warrior-troll-f-70.1b421e20.gif";